import React, { useCallback, useMemo } from "react";
import { MobileAccountBlockStyled, MobileAccountBoxHeaderButtonsStyled } from "../styled/MobileAccountBoxStyled";
import MobileAccountBoxHeader from "../MobileAccountBoxHeader";
import MobileAccountBoxEquity from "../MobileAccountBoxEquity";
import MobileAccountBoxStatPl from "../MobileAccountBoxBlockPl/MobileAccountBoxStatPl";
import { MobileAccountBoxContentStyled } from "./styled/MobileAccountBoxContentStyled";
import { Button } from "react-bootstrap";
import BinIcon from "../../../../components/icon/Icon";
import MobileAccountStatButton from "../MobileAccountStatButton";
import { useSelector } from "react-redux";
import {
    MobileAccountBoxButtonsStyled
} from "../MobileAccountBoxButtonsBlock/styled/MobileAccountBoxButtonsBlockStyled";
import { ACCOUNT_TYPES, FEATURES } from "../../../../app/appConstants";
import parseAccountName from "../../../../utils/parseAccountName";
import { getAppFeatures, getUserSelectedAccountCode } from "../../../../app/appSelectors";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import useMobileAccountBoxButtonsHandlers from "../useMobileAccountBoxButtonsHandlers";
import type { IAccountType } from "../../../../app/types/appActions.t";
import LiteTradeSelectAccountToggle2
    from "../../../../modules/LiteTrade/components/LiteTradeSelectAccount/LiteTradeSelectAccountToggle2";

function MobileAccountBoxAlwaysRespawnContent() {
    const { getLangPath } = useLangContext();
    const accountCode = useSelector(getUserSelectedAccountCode);
    const features = useSelector(getAppFeatures);

    const accountType = useMemo(() => {
        return parseAccountName(accountCode)?.type;
    }, [accountCode]);

    const {
        handleHistoryButtonClick,
        handleWithdrawButtonClick,
        handleDepositButtonClick,
        handleRefillButtonClick,
        handleRespawnButtonClick,
    } = useMobileAccountBoxButtonsHandlers();

    const getSelectAccountToggleComponent = useCallback((
        onClick: (event: any) => void,
        selectedAccount: { accountCode: string, type: IAccountType },
        disabled: boolean
    ) => {
        return <LiteTradeSelectAccountToggle2
            variant={'filled'}
            onClick={onClick}
            type={selectedAccount.type}
            disabled={disabled}/>;
    }, []);

    return <MobileAccountBlockStyled>
        <MobileAccountBoxHeader getSelectAccountToggleComponent={getSelectAccountToggleComponent}/>

        <MobileAccountBoxContentStyled>
            <div className={'d-flex justify-content-between align-items-center'}>
                <div>
                    <MobileAccountBoxEquity/>
                    <MobileAccountBoxStatPl/>
                </div>

                <MobileAccountBoxHeaderButtonsStyled>
                    <MobileAccountStatButton variant={'tertiary'} size={'sm'}/>
                    <Button size={'sm'}
                            variant={'tertiary'}
                            className={'square'}
                            onClick={handleHistoryButtonClick}
                    >
                        <BinIcon name={'IcClock'}/>
                    </Button>
                </MobileAccountBoxHeaderButtonsStyled>
            </div>

            <MobileAccountBoxButtonsStyled>
                {
                    accountType === ACCOUNT_TYPES.LIVE
                        ? <>
                            <Button variant={'secondary'} className={'flex-1'} onClick={handleWithdrawButtonClick}>
                                <BinIcon name={'IcWithdraw'}/>
                                <span>{getLangPath('lite_version.home.withdraw')}</span>
                            </Button>
                            {
                                features[FEATURES.NEW_LIFE] && <>
                                    <Button variant={'secondary'} className={'square'} onClick={handleRespawnButtonClick}>
                                        <BinIcon name={'IcRebuy'} size={'24px'}/>
                                    </Button>
                                </>
                            }
                            <Button variant={'primary'} className={'flex-1'} onClick={handleDepositButtonClick}>
                                <BinIcon name={'IcPlusCircle'}/>
                                <span>{getLangPath('lite_version.home.top_up')}</span>
                            </Button>
                        </>
                        : <Button variant={'secondary'} className={'w-100'} onClick={handleRefillButtonClick}>
                            <BinIcon name={'IcRefill'}/>
                            <span>{getLangPath('lite_version.home.refill')}</span>
                        </Button>
                }
            </MobileAccountBoxButtonsStyled>
        </MobileAccountBoxContentStyled>

    </MobileAccountBlockStyled>;
}

export default MobileAccountBoxAlwaysRespawnContent;

